import esignService from 'Services/EsignService';

export const providersIds = {
    sellsy: 'sellsy',
    docuSign: 'docusign',
};

export default {
    namespaced: true,
    state() {
        return {
            providerSelected: {},
            providers: [],
        };
    },
    getters: {
        isConnected: (state, getters) => {
            return getters.isProviderSellsy ? false : state.providerSelected.is_connected;
        },
        providerSelected: (state) => state.providerSelected,
        providers: (state) => state.providers,
        isProviderSellsy: (state) => state.providerSelected.id === providersIds.sellsy,
    },
    mutations: {
        setProviderSelected(state, payload) {
            state.providerSelected = payload;
        },
        setProviders(state, payload) {
            state.providers = payload;
        },
    },

    actions: {
        fetchProvider({ commit }) {
            return new Promise(
                (resolve, reject) => {
                    esignService
                        .getProviders()
                        .then((response) => {
                            commit('setProviderSelected', response.provider);
                            commit('setProviders', response.available_providers);
                            resolve();
                        })
                        .catch((err) => reject(err));
                },
                (err) => reject(err),
            );
        },
        saveProvider({ commit }, idProviderSelected) {
            return new Promise((resolve, reject) => {
                esignService
                    .saveProvider(idProviderSelected)
                    .then((response) => {
                        commit('setProviderSelected', response.provider);
                        commit('setProviders', response.available_providers);
                        resolve(response);
                    })
                    .catch((err) => reject(err));
            });
        },
    },
};
